// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__NSvP4","title":"Info_title__3WAu2","links":"Info_links__16qdY","link":"Info_link__2sWbi","logo":"Info_logo__24G1v"};